import {DatePicker as KendoDatePicker} from "@progress/kendo-react-dateinputs";
import KendoHOC from "./utils/KendoHOC";

const DatePicker = (options) => (KendoHOC(KendoDatePicker, options));

export default DatePicker;
